const sortByCount = ({ count: a }, { count: b }) => {
  if (a < b) {
    return 1;
  }
  if (a > b) {
    return -1;
  }
  return 0;
};

const generateCountRange = (items) => {
  const range = items.slice(0, 5);
  const other = items.slice(5).reduce((acc, item) => {
    acc.count += item.count;
    return acc;
  }, { label: 'Other', count: 0 });
  if (other.count) {
    range.push(other);
  }
  return range;
};

export const generateStatisticsByMachines = (statistics = [], machines = {}) => statistics
  .reduce((acc, item) => {
    const label = acc.find(l => l.label === item.label);
    const stat = label || { label: item.label };
    const machine = machines[item.machineId];

    stat[machine] = (stat[machine] || 0) + item.count;

    if (!label) {
      acc.push(stat);
    }

    return acc;
  }, []);

export const generateOperatorsStatistics = (statistics = [], operators = {}) => {
  const stat = statistics.map(item => ({
    label: operators[item.opId],
    count: item.count,
  }));
  stat.sort(sortByCount);
  return generateCountRange(stat);
};

export const generateSubstratesStatistics = (statistics = []) => {
  const stat = statistics.map(item => ({
    label: item.substrate,
    count: item.count,
  }));
  stat.sort(sortByCount);
  return generateCountRange(stat);
};

export const generateReprintsStatisticsByMachines = (statistics = [], machines = {}) => {
  const stat = statistics.map(item => ({
    label: machines[item.machineId],
    count: item.count,
  }));
  stat.sort(sortByCount);
  return generateCountRange(stat);
};

export const generateTotalStatistics = (statistics = []) => {
  const stat = statistics.reduce((acc, item) => {
    const machines = [];
    Object.keys(item).forEach((k) => {
      if (k === 'label') {
        return;
      }
      const machine = acc.find(m => m.label === k);
      const m = machine || { label: k };
      m.count = (m.count || 0) + item[k];
      if (!machine) {
        machines.push(m);
      }
    });
    acc.push(...machines);
    return acc;
  }, []);
  stat.sort(sortByCount);
  return generateCountRange(stat);
};

export default {};
